{
  "INTEGRATION_APPS": {
    "FETCHING": "Preuzimanje integracija",
    "NO_HOOK_CONFIGURED": "Nema {integrationId} integracija podešenih na ovom nalogu.",
    "HEADER": "Aplikacije",
    "STATUS": {
      "ENABLED": "Omogućeno",
      "DISABLED": "Onemogućeno"
    },
    "CONFIGURE": "Podesi",
    "ADD_BUTTON": "Dodaj novu zakačku",
    "DELETE": {
      "TITLE": {
        "INBOX": "Potvrdi brisanje",
        "ACCOUNT": "Prekini vezu"
      },
      "MESSAGE": {
        "INBOX": "Da li zaista želite da obrišete?",
        "ACCOUNT": "Da li zaista želite da prekinete vezu?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Da, obriši",
        "ACCOUNT": "Da, prekini vezu"
      },
      "CANCEL_BUTTON_TEXT": "Otkaži",
      "API": {
        "SUCCESS_MESSAGE": "Zakačka je uspešno obrisana",
        "ERROR_MESSAGE": "Nije moguće se povezati sa Woot serverom, pokušajte ponovo kasnije"
      }
    },
    "LIST": {
      "FETCHING": "Preuzimanje zakački integracija",
      "INBOX": "Prijemno sanduče",
      "EDIT": {
        "BUTTON_TEXT": "Izmeni"
      },
      "DELETE": {
        "BUTTON_TEXT": "Izbriši"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Izaberi prijemno sanduče",
          "PLACEHOLDER": "Izaberi prijemno sanduče"
        },
        "SUBMIT": "Napravi",
        "CANCEL": "Otkaži"
      },
      "API": {
        "SUCCESS_MESSAGE": "Zakačka integracije je uspešno dodata",
        "ERROR_MESSAGE": "Nije moguće se povezati sa Woot serverom, pokušajte ponovo kasnije"
      }
    },
    "EDIT": {
      "TITLE": "Izmeni {name}",
      "FORM": {
        "SUBMIT": "Ažuriraj",
        "CANCEL": "Otkaži"
      },
      "API": {
        "SUCCESS_MESSAGE": "Zakačka integracije je uspešno ažurirana",
        "ERROR_MESSAGE": "Nije moguće se povezati sa Woot serverom, pokušajte ponovo kasnije"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Poveži"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Prekini vezu"
    },
    "SIDEBAR_DESCRIPTION": {
      "CUSTOM_DATA_PROVIDER": "Fetch data from your own server and display it in the conversation sidebar. Returns HTML (shown in an iframe) or JSON (shown as a key/value list).",
      "DIALOGFLOW": "Dialogflow is a natural language processing platform for building conversational interfaces. Integrating it with {installationName} lets bots handle queries first and transfer them to agents when needed. It helps qualify leads and reduce agent workload by answering FAQs. To add Dialogflow, create a Service Account in Google Console and share the credentials. Refer to the docs for details",
      "DAKTELA": "Sinhronizujte e-poštu i veb-čatove sa vašim daktela nalogom.",
      "RETINO": "Retino unosi red u upravljanje povratima i reklamacijama.",
      "MAILSHIP": "Mailship je sistem za upravljanje skladištem i realizacijom porudžbina. Proverite status porudžbine, praćenje pošiljke i detalje otpreme.",
      "RAYNET": "Повежите свој Raynet CRM налог да бисте приступили подацима о клијентима. Додајте везу помоћу свог Raynet корисничког имена и API токена."
    },
    "TEST_CONNECTION": {
      "BUTTON": "Тестирај везу",
      "SUCCESS": "Веза је успешна",
      "ERROR": "Повезивање није успело. Проверите своје акредитиве."
    }
  }
}
